import  { useState } from 'react'
import { Link } from 'react-router-dom';
import TablePagination from '../../../common/TablePagination';

const SchoolRecordVer2List = ({ list }) => {
    /* Pagination */
    const itemsPerPage = 10
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + itemsPerPage;
    const currentItems = list.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(list.length / itemsPerPage);
    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % list.length;
        setItemOffset(newOffset);
    };

    return (
        <div className='py-3'>
            <table className="table table-hover align-middle">
                <colgroup>
                    <col width={"100px"} />
                    <col width={"auto"} />
                    <col width={"140px"} />
                </colgroup>
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">제목</th>
                        <th scope="col">작성일</th>
                    </tr>
                </thead>
                <tbody>
                    {currentItems.map((item, index) => {
                        let no = list.length - index
                        let id = item.school_record_id
                        let title = item.title
                        let date = item.created_at

                        return (
                            <tr key={index}>
                                <td>{no}</td>
                                <td>
                                    <Link to={`/school-record/${id}`} className='d-block py-2 text-black fw-semibold'>{title}</Link>
                                </td>
                                <td>{date}</td>
                            </tr>
                        )
                    })}

                </tbody>
            </table>

            <div className='pt-3 pgn-custom text-center'>
                <TablePagination handlePageClick={handlePageClick} pageCount={pageCount} pageClass='page-item' linkClass='page-link' />
            </div>
        </div>
    )
}

export default SchoolRecordVer2List